module.exports = __webpack_public_path__ + "static/new-engen-lift.377722ad.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-engen-lift.jpeg
// module id = 413
// module chunks = 159014900043430